export const styles = {
  container: "",

  items: "",

  item: "",
  item_title:
    "flex justify-between items-start w-full cursor-pointer py-6",
  item_icon: "w-6 pt-1 lg:pt-4",
  item_content:
    "overflow-y-auto scrollbar-hide",
};

export type HyamPrismicAccordionStyles =
  typeof styles;

export const animationProps = {
  item: {
    initial: "close",
    animate: "close",
    variants: {
      close: {},
      open: {},
    },
  },
  item_content: (height: number) => ({
    variants: {
      close: {
        maxHeight: "0px",
        transition: {
          duration: height / 500,
          ease: "easeInOut",
        },
      },
      open: {
        maxHeight: height + "px",
        transition: {
          duration: height / 500,
          ease: "easeInOut",
        },
      },
    },
  }),
};
